var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('auth',{attrs:{"type":'user',"userId":_vm.formData.operationId},on:{"authData":_vm.authData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }